import { Input, Space } from "antd"
import { Subcontractor } from "./subcontractorModel"
import BudgetInputNumber from "./BudgetInputNumber"
import AddRemove from './AddRemove'
import BudgetStatistic from "./BudgetStatistic"
import BudgetTable from './BudgetTable'
import { useContext } from "react"
import BudgetCalculatorContext from "./BudgetCalculatorContext"

const Subcontractors = () => {
  const { worksheet: { data: { subcontractors } }, summary, dispatch } = useContext(BudgetCalculatorContext)

  const columns = [
    {
      title: 'Expense',
      dataIndex: 'description',
      key: 'description',
      render: (value: string, _: Subcontractor, index: number) => {
        return <Input value={value} onChange={e => dispatch({ type: 'SUBCONTRACTOR_DESCRIPTION_CHANGED', index, payload: e.target.value })} />
      }
    },
    {
      title: 'Monthly Cost',
      key: 'monthlyCost',
      render: (_: number, record: Subcontractor, index: number) => {
        return <BudgetInputNumber
          value={Math.round((record.annualCost ?? 0) / 12)}
          money
          onChange={(e) => dispatch({ type: 'SUBCONTRACTOR_ANNUAL_COST_CHANGED', index, payload: e * 12 })} />
      }
    },
    {
      title: 'Annual Cost',
      dataIndex: 'annualCost',
      key: 'annualCost',
      render: (value: number, _: Subcontractor, index: number) => {
        return <BudgetInputNumber
          value={value}
          money
          onChange={(e) => dispatch({ type: 'SUBCONTRACTOR_ANNUAL_COST_CHANGED', index, payload: e })} />
      }
    },
    {
      key: 'operations',
      render: (_: number, _record: Subcontractor, index: number) => {
        return <AddRemove
          onAdd={() => dispatch({ type: 'ADD_SUBCONTRACTOR', index })}
          onRemove={() => dispatch({ type: 'REMOVE_SUBCONTRACTOR', index })} />
      }
    }
  ]

  return <Space direction="vertical" size="large">
    <BudgetStatistic title="Total Annual Cost" value={summary.subcontractors} statisticStyle="dollars" />
    <BudgetTable
      columns={columns}
      dataSource={subcontractors}
    />
  </Space>
}
export default Subcontractors
